import client from '../../base-api';

const serviceURL = '/dashboard/accountant';

const dashboardAccountantService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },

    getChartData(filterData: any) {
        return client.get(`${serviceURL}/units-done-chart/${filterData?.year}/${filterData?.coachingType}/${filterData?.locationId}`);
    },

    getPotentialUnitsData(filterData: any) {
        return client.get(`${serviceURL}/potential-units`, {params: filterData});
    },
}

export default dashboardAccountantService;